
const checkRangeDate = (startDate, endDate) => {
  let isCorrectRangeData = true;
  let errorMsg = [];
  let now =  Date.now();

  if (startDate > endDate) {
    isCorrectRangeData = false;
    errorMsg.push("la data inizio periodo è superiore alla data di fine periodo");
  }

  if (endDate.Date > now.Date) {
    isCorrectRangeData = false;
    errorMsg.push("la data fine periodo è superiore alla data attuale");
  }

  if (startDate.Date > now.Date) {
    isCorrectRangeData = false;
    errorMsg.push("la data inizio periodo è superiore alla data attuale");
  }

  return { errorMsg, isCorrectRangeData, startDate, endDate };
};

export { checkRangeDate };
